(() => {
  const roots = document.querySelectorAll('[data-hf-supp-v4]');
  roots.forEach((root) => {
    if (root.dataset.sv4Ready === '1') return;
    root.dataset.sv4Ready = '1';

    const gallery = root.querySelector('[data-sv4-gallery]');
    if (gallery) {
      const thumbs = [...gallery.querySelectorAll('[data-sv4-thumb]')];
      const media = [...gallery.querySelectorAll('[data-sv4-media]')];
      const dots = [...gallery.querySelectorAll('[data-sv4-dot]')];
      let index = Math.max(0, media.findIndex((el) => el.classList.contains('is-active')));
      const activate = (next) => {
        if (!media.length) return;
        index = (next + media.length) % media.length;
        media.forEach((el, i) => {
          const active = i === index;
          el.hidden = !active;
          el.classList.toggle('is-active', active);
          if (!active) el.querySelectorAll('video').forEach((v) => { try { v.pause(); } catch (_) {} });
        });
        thumbs.forEach((el, i) => {
          const active = i === index;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && window.innerWidth < 750) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dots.forEach((el, i) => el.classList.toggle('is-active', i === index));
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => activate(i)));
      const stage = gallery.querySelector('.sv4-stage');
      let sx = null, sy = null;
      stage?.addEventListener('touchstart', (e) => {
        const t = e.changedTouches?.[0];
        if (t) { sx = t.clientX; sy = t.clientY; }
      }, { passive: true });
      stage?.addEventListener('touchend', (e) => {
        const t = e.changedTouches?.[0];
        if (!t || sx === null) return;
        const dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) activate(index + (dx < 0 ? 1 : -1));
        sx = sy = null;
      }, { passive: true });
    }

    const qty = root.querySelector('[data-sv4-qty]');
    root.querySelector('[data-sv4-minus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });
    root.querySelector('[data-sv4-plus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });

    const select = root.querySelector('[data-sv4-variant]');
    const add = root.querySelector('[data-sv4-add]');
    const addLabel = root.querySelector('[data-sv4-add-label]');
    const price = root.querySelector('[data-sv4-price]');
    const stickyPrice = root.querySelector('[data-sv4-sticky-price]');
    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option?.dataset.available === 'true';
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'AGREGAR AL CARRITO' : 'Agotado';
      if (option?.dataset.priceFormatted) {
        if (price) price.textContent = option.dataset.priceFormatted;
        if (stickyPrice) stickyPrice.textContent = option.dataset.priceFormatted;
      }
    });

    const sticky = root.querySelector('[data-sv4-sticky]');
    const stickyAdd = root.querySelector('[data-sv4-sticky-add]');
    const form = root.querySelector('.sv4-product-form');
    if (sticky && add && window.matchMedia('(max-width: 749px)').matches) {
      const io = new IntersectionObserver((entries) => {
        sticky.hidden = !!entries[0]?.isIntersecting;
      }, { threshold: 0.05 });
      io.observe(add);
      stickyAdd?.addEventListener('click', () => {
        if (form?.requestSubmit) form.requestSubmit(add);
        else add.click();
      });
    }
  });
})();
